import { FormControlLabel, Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import DyanmicFrom from "../../../DyanmicForm/DyanmicFrom";
import DataCard from "../DataCard";
import FromData from "../DealCard/FormCard";
import FormCard1 from "../DealCard/FormCard1";
import { message } from "antd";
import CustomSubmit from "./CustomSubmit";
import GroupedCollapsibleList from "../../../UI/GroupedCollapsibleList";

// Walks from `index` in `direction` (-1 or 1) and returns the index of the
// nearest item sharing the same groupBy value, or -1 if none.
const findAdjacentInGroup = (arr, index, groupBy, direction) => {
  const groupValue = arr[index]?.[groupBy];
  for (let i = index + direction; i >= 0 && i < arr.length; i += direction) {
    if (arr[i]?.[groupBy] === groupValue) return i;
  }
  return -1;
};

const Custom2StageForm = ({
  preview,
  dataCard,
  setDataCard,
  children,
  error,
  oldData,
  rootData,
  updateComponentData,
  page_id,
  level2,
  level1,
  reverseOrder,
  groupBy,
}) => {
  const [activeSection, setActiveSection] = useState();
  const [active, setActive] = useState(false);

  const [cardData, setCardData] = useState({
    image: null,
    title: "",
    simplified_chinese_title: "",
    traditional_chinese_title: "",
  });
  useEffect(() => {
    if (oldData) setDataCard(oldData);
  }, [oldData]);

  useEffect(() => {
    setActive(preview);
  }, [preview]);

  const addData = (index, cardData, type) => {
    let array = [];
    if (type) {
      array = [...dataCard.dataArray];
      array[index] = cardData;
    } else if (dataCard.dataArray) array = [...dataCard.dataArray, cardData];
    else array = [cardData];
    setDataCard({ ...dataCard, dataArray: array });
    if (type) {
      message.success("data updated click on publish to publish changes");
    } else {
      message.success("Created");
    }
  };
  const handleUp = (index) => {
    let arr = dataCard?.dataArray;
    if (!arr) return;
    const swapIndex = groupBy
      ? findAdjacentInGroup(arr, index, groupBy, -1)
      : index - 1;
    if (swapIndex < 0) return;
    let val = arr[index];
    arr[index] = arr[swapIndex];
    arr[swapIndex] = val;
    setDataCard({ ...dataCard, dataArray: arr });
  };

  const handleDown = (index) => {
    let arr = dataCard?.dataArray;
    if (!arr) return;
    const swapIndex = groupBy
      ? findAdjacentInGroup(arr, index, groupBy, 1)
      : index + 1;
    if (swapIndex < 0 || swapIndex >= arr.length) return;
    let val = arr[index];
    arr[index] = arr[swapIndex];
    arr[swapIndex] = val;
    setDataCard({ ...dataCard, dataArray: arr });
  };

  const handleChange = (event) => {
    setActive(event.target.checked);
  };
  const displayArray = reverseOrder
    ? [...(dataCard?.dataArray || [])].reverse()
    : dataCard?.dataArray || [];

  const cardEntries = displayArray.map((item, displayIndex) => {
    const originalIndex = reverseOrder
      ? (dataCard?.dataArray?.length || 0) - 1 - displayIndex
      : displayIndex;
    return { item, originalIndex };
  });

  const renderCard = ({ item, originalIndex }) => (
    <DataCard
      key={originalIndex}
      color="#f7f7f7"
      title={item?.title}
      activeDrop={activeSection}
      rootData={rootData}
      handleup={handleUp}
      handledown={handleDown}
      setActiveDrop={setActiveSection}
      index={originalIndex}
      array={dataCard?.dataArray}
      setArray={(e) => {
        setDataCard({ ...dataCard, dataArray: e });
      }}
    >
      <FromData
        attributes={level2}
        active={activeSection == originalIndex}
        data={item}
        updateData={addData}
        rootData={rootData}
        index={originalIndex + 1}
      />
    </DataCard>
  );

  // groupBy (e.g. "ship") groups this section's cards into collapsible
  // sections instead of one flat list — see GroupedCollapsibleList.
  const groupField = groupBy
    ? (level2 || []).find((field) => field.key === groupBy)
    : undefined;

  const actionButtons = (
    <>
      <FormCard1 button={"Card"} add updateData={addData} />
      {page_id && (
        <CustomSubmit
          data1={dataCard}
          data2={oldData}
          handleSubmit={() => updateComponentData(dataCard)}
        />
      )}
    </>
  );

  return (
    <div className="card">
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        {" "}
        <FormControlLabel
          control={<Switch checked={active} onChange={handleChange} />}
          label="Preview"
        />
      </div>

      {active && children}
      {!active && (
        <div className="card-body">
          <div className="row">
            <DyanmicFrom
              error={error}
              rootData={rootData}
              level={1}
              attributes={level1 || []}
              data={dataCard}
              setData={(e) => {
                setDataCard(e);
              }}
            />
          </div>
          {reverseOrder && actionButtons}
          <GroupedCollapsibleList
            entries={cardEntries}
            getGroupValue={groupBy ? (entry) => entry.item?.[groupBy] : undefined}
            groupField={groupField}
            rootData={rootData}
            renderItem={renderCard}
          />
          {!reverseOrder && actionButtons}
        </div>
      )}
    </div>
  );
};

export default Custom2StageForm;
